import { grey } from "designSystem/styles/color";
import { Box, MasonryGrid } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";
import Image1 from "./Image1.jpg";
import Image2 from "./Image2.jpg";
import Image4 from "./Image4.jpg";
import Image7 from "./Image7.jpg";

export default () => {
	const imgList = [
		{
			link: Image1,
			height: 360,
			width: 180,
		},
		{
			link: Image2,
			height: 370,
			width: 185,
		},
		{
			height: 128,
			width: 100,
		},
		{
			link: Image4,
			height: 370,
			width: 185,
		},
		{
			link: Image7,
			height: 412,
			width: 735,
		},
	];

	return (
		<Box
			bgcolor={grey[100]}
			border={STANDARD_BORDER_STYLE}
			display="inline-block"
			height={400}
			m={4}
			width={300}
		>
			<MasonryGrid imageList={imgList} topDown />
		</Box>
	);
};